import { m } from "framer-motion";

export const mentalplus = {
  mentalplus_tab_help: 'عَوّامَتي',
  mentalplus_tab_videos: 'فيديوهات',
  mentalplus_tab_home: 'عالمي',
  mentalplus_tab_evolution: 'التطور',
  mentalplus_tab_account: 'الحساب',
  mentalplus_tab_questionnaires: 'الاستبيانات',
  mentalplus_account_page_title: 'الحساب والإعدادات',
  mentalplus_account_manage: 'إدارة حسابي',
  mentalplus_account_deactivate: 'تعطيل حسابي',
  mentalplus_account_deactivate_message: 'هل تريد تعطيل حسابك؟',
  mentalplus_account_notifications: 'إدارة الإشعارات',
  mentalplus_account_notification_email: 'إشعارات البريد الإلكتروني',
  mentalplus_account_notification_sms: 'إشعارات الرسائل القصيرة',
  mentalplus_account_notification_push: 'الإشعارات الفورية',
  mentalplus_account_notification_add_contact: 'أضف جهة اتصال لتفعيل هذا النوع من الإشعارات',
  mentalplus_account_notification_push_hint: 'فعّلها لتلقي الإشعارات على هذا الجهاز',
  mentalplus_account_notification_push_permission_required: 'تم رفض الإذن. فعّل الإشعارات من إعدادات المتصفح أو الجهاز.',
  mentalplus_unsubscribe_title: 'تفضيلات الإشعارات',
  mentalplus_unsubscribe_intro: 'أدِر الإشعارات التي تتلقاها من هذه الدراسة.',
  mentalplus_unsubscribe_save: 'حفظ',
  mentalplus_unsubscribe_saved: 'تم حفظ تفضيلاتك.',
  mentalplus_unsubscribe_error: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  mentalplus_unsubscribe_invalid: 'لم يعد رابط إلغاء الاشتراك هذا صالحًا.',
  mentalplus_unsubscribe_push_note: 'لتفعيل الإشعارات الفورية، افتح التطبيق.',
  mentalplus_unsubscribe_loading: 'جارٍ تحميل تفضيلاتك…',
  mentalplus_account_tutorials: 'عرض الشروحات',
  mentalplus_account_language: 'تغيير اللغة',
  mentalplus_account_about: 'حول التطبيق',
  mentalplus_account_contact: 'اتصل بنا',
  mentalplus_account_app_version: 'إصدار التطبيق',
  mentalplus_filtre_ile: 'جزيرة',
  mentalplus_tab_ile_moi: 'أنا',
  mentalplus_tab_ile_amour: 'حب',
  mentalplus_tab_ile_famille: 'عائلة',
  mentalplus_tab_ile_amis: 'أصدقاء',
  mentalplus_tab_ile_ecrans: 'شاشة',
  mentalplus_tab_ile_loisirs: 'تسلية',
  mentalplus_video_filtres: 'فلاتر',
  mentalplus_video_enregistrees: 'المحفوظة',
  mentalplus_videos_enregistrees: 'الفيديوهات المحفوظة',
  mentalplus_video_rechercher: 'بحث',
  mentalplus_help_signes: 'علامات',
  mentalplus_help_solutions: 'حلول',
  mentalplus_help_num_soutiens: 'أرقام الدعم',
  mentalplus_help_num_utiles: 'أرقام مفيدة',
  mentalplus_help_signes_question: 'ما هي العلامات التي تجعلني أدرك أنني بدأت أشعر بالسوء؟',
  mentalplus_help_solutions_question: 'ما هي الحلول التي يمكن أن تساعدني على الشعور بتحسن؟',
  mentalplus_help_num_epingle: 'رقم مثبت',
  mentalplus_help_num_epingle_choix: 'اختر الرقم لتثبيته',
  mentalplus_help_num_valider: 'تأكيد هذا الرقم',
  mentalplus_help_num_gerer: 'إدارة أرقام الطوارئ الخاصة بي',
  mentalplus_help_num_gerer_proches: 'إدارة أرقام جهات الاتصال المقربة',
  mentalplus_help_num_enregistrer: 'حفظ',
  mentalplus_help_solutions_ajouter: 'إضافة حل',
  mentalplus_help_ajouter: 'إضافة',
  mentalplus_help_signes_ajouter: 'إضافة علامة',
  mentalplus_help_num_proches_ajouter: 'إضافة جهة اتصال مقربة',
  mentalplus_help_num_proches_nom: 'اسم جهة الاتصال (مثال: أبي)',
  mentalplus_help_num_proches_nom_numero: 'رقم الهاتف',
  mentalplus_help_num_urgences: 'أرقام الطوارئ',
  mentalplus_help_num_proches: 'جهات الاتصال المقربة',
  mentalplus_video_retour: 'رجوع',
  mentalplus_video_description: 'الوصف',
  mentalplus_video_voir_plus: 'عرض المزيد',
  mentalplus_video_description_empty: 'لا يوجد وصف لهذا الفيديو.',
  mentalplus_video_tout_voir: 'عرض الجميع',
  mentalplus_video_renitialiser: 'إعادة تعيين',
  mentalplus_filtre_categories: 'فئات',
  mentalplus_filtre_categories_explications: 'توضيحات',
  mentalplus_filtre_categories_solutions: 'حلول',  
  mentalplus_filtre_realisee: 'من صنع',
  mentalplus_filtre_realisee_professionnels: 'مهنيون',
  mentalplus_filtre_realisee_communaute: 'المجتمع',
  mentalplus_filtre_realisee_2: 'مصنوعة ل',
  mentalplus_filtre_realisee_collegiens: 'طلاب المدارس الإعدادية',
  mentalplus_filtre_realisee_lyceens: 'طلاب المدارس الثانوية',  
  mentalplus_filtre_realisee_etudiants: 'طلاب الجامعات',
  mentalplus_filtre_realisee_jeunes_actifs: 'الشباب النشيط',
  mentalplus_filtre_realisee_sans_activite: 'بدون نشاط',
  mentalplus_filtre_trier: 'ترتيب حسب',
  mentalplus_filtre_trier_popularite: 'الشعبية',
  mentalplus_filtre_trier_recent: 'الأحدث',
  mentalplus_filtre_trier_ancien: 'الأقدم',
  mentalplus_menu_share: 'مشاركة {{appName}}',
  mentalplus_menu_profile: 'الملف الشخصي',
  mentalplus_menu_island_settings: 'إعدادات الجزيرة',
  menu_share: 'مشاركة',
  mentalplus_menu_conatct: 'اتصل بنا',  
  mentalplus_menu_objet: 'الموضوع',
  mentalplus_menu_objet_champ: 'اختر موضوعًا',
  mentalplus_menu_equipe: 'من نحن؟',
  mentalplus_menu_signaler_un_bug: 'الإبلاغ عن خطأ',  
  mentalplus_menu_contacter_l_equipe: 'اتصل بالفريق',
  mentalplus_menu_autre: 'أخرى',
  mentalplus_menu_que_faire: 'ماذا أفعل؟',
  mentalplus_menu_son: 'الصوت',
  mentalplus_video_recherche: 'لا يوجد فيديو يطابق هذه الفلاتر.',
  mentalplus_ile_moi_quizz: 'اختبار القلق والاكتئاب',
  mentalplus_video_enregistree: 'لا توجد فيديوهات محفوظة في الوقت الحالي.',
};  
  